import { aboutImage } from "@/mocks/images";

export default function About() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="nosotros" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-center">
          {/* Left: Images */}
          <div className="w-full lg:w-1/2 relative">
            <div className="relative rounded-2xl overflow-hidden w-full h-[420px] md:h-[500px]">
              <img
                src={aboutImage}
                alt="Piscina terminada por SUPERPISCINAS FLORIN"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/50 to-transparent"></div>
              <div className="absolute bottom-4 left-4 bg-white/10 backdrop-blur-md border border-white/20 rounded-xl px-4 py-3">
                <p className="text-white font-semibold text-sm">Gunitado de Piscina</p>
                <p className="text-cyan-300 text-xs">Completado en 2024</p>
              </div>
            </div>
            {/* Floating card */}
            <div className="absolute -bottom-6 -right-4 md:-right-8 bg-cyan-500 text-white rounded-2xl px-6 py-5 shadow-xl">
              <div className="text-3xl font-extrabold">+250</div>
              <div className="text-sm font-medium opacity-90">Piscinas Construidas</div>
            </div>
          </div>

          {/* Right: Text */}
          <div className="w-full lg:w-1/2 pt-8 lg:pt-0">
            <span className="text-cyan-500 text-sm font-semibold uppercase tracking-widest">Sobre Nosotros</span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-slate-800 mt-3 mb-6 leading-tight">
              Más de 16 años construyendo{" "}
              <span className="text-cyan-500">piscinas de calidad</span>
            </h2>
            <p className="text-slate-600 text-base leading-relaxed mb-6">
              <strong>SUPERPISCINAS FLORIN</strong> es una empresa especializada en la construcción, mantenimiento y limpieza de piscinas. Desde 2010, hemos transformado espacios exteriores en auténticos paraísos acuáticos para familias, hoteles y comunidades de toda España.
            </p>
            <p className="text-slate-600 text-base leading-relaxed mb-8">
              Nuestro equipo de profesionales altamente cualificados trabaja con los mejores materiales y las últimas tecnologías para garantizar resultados excepcionales. Cada proyecto es único y lo tratamos con la máxima dedicación y cuidado.
            </p>

            {/* Values */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
              {[
                { icon: "ri-shield-check-line", title: "Calidad Garantizada", desc: "Materiales premium y acabados perfectos" },
                { icon: "ri-time-line", title: "Puntualidad", desc: "Cumplimos plazos y compromisos" },
                { icon: "ri-team-line", title: "Equipo Experto", desc: "Profesionales con más de 16 años" },
                { icon: "ri-customer-service-2-line", title: "Servicio 24/7", desc: "Siempre disponibles para ti" },
              ].map((v) => (
                <div key={v.title} className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-cyan-50 rounded-xl flex-shrink-0">
                    <i className={`${v.icon} text-cyan-500 text-lg`}></i>
                  </div>
                  <div>
                    <p className="font-semibold text-slate-800 text-sm">{v.title}</p>
                    <p className="text-slate-500 text-xs mt-0.5">{v.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <button
              onClick={() => scrollTo("contacto")}
              className="bg-slate-800 hover:bg-slate-700 text-white font-semibold px-7 py-3.5 rounded-full transition-all cursor-pointer whitespace-nowrap"
            >
              Contáctanos hoy →
            </button>
          </div>
        </div>

        {/* Why choose us */}
        <div className="mt-24">
          <div className="text-center mb-12">
            <span className="text-cyan-500 text-sm font-semibold uppercase tracking-widest">¿Por qué elegirnos?</span>
            <h3 className="text-3xl md:text-4xl font-extrabold text-slate-800 mt-3">
              La diferencia SUPERPISCINAS FLORIN
            </h3>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { icon: "ri-award-line", num: "+16", label: "Años de Experiencia", color: "bg-cyan-50 text-cyan-600" },
              { icon: "ri-tools-line", num: "100%", label: "Garantía en Trabajos", color: "bg-teal-50 text-teal-600" },
              { icon: "ri-map-pin-line", num: "Toda", label: "España Cubierta", color: "bg-sky-50 text-sky-600" },
              { icon: "ri-star-line", num: "5★", label: "Valoración Media", color: "bg-amber-50 text-amber-600" },
            ].map((item) => (
              <div key={item.label} className="bg-white border border-slate-100 rounded-2xl p-6 text-center hover:shadow-md transition-all">
                <div className={`w-14 h-14 flex items-center justify-center rounded-2xl mx-auto mb-4 ${item.color}`}>
                  <i className={`${item.icon} text-2xl`}></i>
                </div>
                <div className="text-3xl font-extrabold text-slate-800 mb-1">{item.num}</div>
                <div className="text-slate-500 text-sm">{item.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
